



































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiActivity from '@/api/activity'
import { toSubArray } from '@/utils/groupBy'
import ReadContent from '@/components/administration/activity/read/ReadContent.vue'
import ReadPage from '@/components/administration/activity/read/ReadPage.vue'
import ReadImage from '@/components/administration/activity/read/ReadImage.vue'
import ReadSeo from '@/components/administration/activity/read/ReadSeo.vue'
import { AloActivity, getDefaultAloActivity } from '@/models/alo/AloActivity'
import { directPayloadQuery } from '@/utils/api'
import {DashboardAdmin} from '@/router/pages'
import cloneDeep from 'clone-deep'
import { AloMedia, getDefaultAloMedia } from '@/models/alo/AloMedia'


@Component({
  name: 'ModifyActivity', 
  props: {
    activityId:Number
  },
  components: { ReadContent,ReadSeo,ReadPage,ReadImage },
})

export default class ModifyActivity extends Vue {
  activityId!: number
  private showError = false    
  private rightDrawer = false
  private loading = false

  get activity(){
    return this.$store.myGetters.activityDic[this.activityId] || getDefaultAloActivity()
  }



  loadActivity() {    
    this.loading = true    
    this.$store.myActions.ADM_ACTIVITY_DETAIL_REQUEST(this.activityId).finally(() => {      
      this.loading = false
    })    
  }

  created(){
    this.loadActivity()
  }  

  get arianeItems() {
    const arianeItems =  [
        DashboardAdmin,
        {
          text: 'Activités',
          disabled: false,  
          to: {name:'AdminActivity'},        
          exact:true
        }
      ]
    if(this.activity) {
        arianeItems.push({
          text: this.activity.libelle,
          disabled: true,             
          to: {name:''},                         
          exact:true
        })
    }
    return arianeItems;
  } 

}
